
    function show_product_devicegroups_tab(product, type) {
        console.warn('this version of show product devicegroups has been deprecated');
    }

    export default show_product_devicegroups_tab;

